import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  position: fixed;
  width: 100%;
  z-index: 10;

  .ant-layout-header {
    padding: 0 16px;

    @media (min-width: 1025px) {
      padding: 0 24px;
    }

    .ant-menu {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: flex-end;
      max-height: 64px;

      .ant-menu-item.mobile {
        @media (min-width: 1024px) {
          display: none;
        }
      }
    }
  }
`;

export const StyledNavLink = styled.div<{ active?: string }>`
  display: inline;
  padding: 0.5em;
  margin: 0 1em;
  border-bottom: 2px solid transparent;
  color: ${({ active }) => (active ? '#015989;' : 'rgba(0,0,0,0.7);')};
  cursor: pointer;
  transition: color 0.3s linear, opacity 0.3s linear;

  &:hover {
    opacity: 0.8;
    color: #015989;
  }
`;

export const LogoWrapper = styled.div`
  float: left;
`;

export const IntelbrasLogoWrapper = styled.div`
  float: left;
  height: 100%;
  a {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-around;
    position: relative;
    color: #029436;
  }
  img {
    position: relative;
    top: 3px;
  }
  span {
    position: relative;
    left: 130px;
    width: 52px;
    height: 20px;
    line-height: 20px;
    white-space: nowrap;
  }
`;
